import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  email: Yup.string().email('form.validation.email.invalid').required('form.validation.email.required'),
  password: Yup.string().required('form.validation.email.required'),
  terms: Yup.boolean().oneOf([true], 'form.validation.termsAndConditions.required'), // Ensure the checkbox is checked
});
